

import FieldValidatorByRules from "@/mixins/field/FieldValidatorByRules";
import RegExpSwift from "@/mixins/reg-exp/reg-exp-swift";
import { EFieldValueTransform } from "@/views/Counterparties/interface";
import { VueMaskDirective as mask } from "v-mask";
import { Component, Emit, InjectReactive, Mixins, Prop, Watch } from "vue-property-decorator";
import FieldCustomValidity from "@/mixins/field/FieldCustomValidity";
import FormOnChange from "@/components/Form/mixins/FormOnChange";
import MaskUtils from "@/modules/Mask/MaskUtils";
import TestProps from '@/mixins/test/TestProps';
import FormTransform from "../Form/mixins/FormTransform";
import IBSVGIconClose from "../SVGIcon/IBSVGIconClose.vue";
import IBSpinnerLoading from "../IBLoading/IBSpinnerLoading.vue";

@Component({
	directives: {
		mask
	},
	components: {
		IBSVGIconClose,
		IBSpinnerLoading,
	}
})
export default class TextField extends Mixins(
	FieldCustomValidity,
	FieldValidatorByRules,
	RegExpSwift,
	FormOnChange,
	TestProps,
	FormTransform,
) {

	@Prop({ type: String, default: "" }) readonly label!: string;
	@Prop({ type: String, default: "" }) readonly value!: string;

	@Prop({ type: String, default: "" }) readonly id!: string;

	@Prop({ type: String, default: "text" }) readonly type!: string;

	@Prop({ type: String, default: "" }) readonly icon!: string

	@Prop({ type: String, default: "" }) readonly prependIcon!: string;

	@Prop({ type: String, default: "" }) readonly appendIcon!: string;

	@Prop({ type: String, default: "" }) readonly errorMessage!: string;

	@Prop({ type: [ String, Object ], default: "" }) readonly className!: any;

	@Prop({ type: Number, default: null }) readonly maxlength!: number;
	@Prop({ type: Number, default: null }) readonly minlength!: number;

	@Prop({ type: Boolean, default: false }) readonly disabled!: boolean;

	@Prop({ type: Boolean, default: false }) readonly payrollHistoryInfo!: boolean;

	@Prop({ type: Boolean, default: true }) readonly required!: boolean;

	@Prop({ type: Boolean, default: false }) readonly valid!: boolean;

	@Prop({ type: Boolean, default: false }) readonly isKnp!: boolean;

	@Prop({ type: Boolean, default: false }) readonly isNumbers!: boolean;

	@Prop({ type: Boolean, default: false }) readonly readonly!: boolean;

	@Prop({ type: Boolean, default: false }) readonly isInputClear!: boolean;

	@Prop({ type: Boolean, default: false }) readonly regexp!: boolean;

	@Prop({ type: Boolean, default: false }) readonly autofocus!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly iconDisplayStart: boolean;

  @Prop({ type: Boolean, default: false }) readonly customValidation!: boolean;

	@Prop(RegExp)
	readonly customRegExp?: RegExp

	@Prop(Boolean)
	readonly excludeBreaks?: boolean

	@Prop(String)
	readonly transform!: EFieldValueTransform;

	@InjectReactive()
	readonly textFieldShowError!: boolean

	@Prop(String)
	readonly info?: string

	@Prop(String)
	readonly errorMessageForRules?: string

	@Prop(Boolean)
	readonly clearable?: boolean

	@Prop(Boolean)
	readonly loading?: boolean

  @Prop({ type: Boolean, default: false })
  readonly sliceDisabled?: boolean;

  @Prop({ type: Boolean, default: false })
  readonly withoutFocus!: boolean;

	isFocus: boolean;
	isActive: boolean;
	inputValue: string;
	formattedCurrencyValue: string | number;
	hasError: boolean = false;
	customErrorMessage: string = '';

	$refs!: {
		input: HTMLInputElement
	};

	constructor() {
		super();

		this.inputValue = "";
		this.formattedCurrencyValue = "";

		this.isFocus = false;
		this.isActive = false;
	}

	onPaste(evt: any) {
		const regexpNumber = /^([0-9])+$/g;
		const regexp = this.getRegExp();

		if (this.isNumbers) {
			this.isRegexp(regexpNumber, evt, evt.clipboardData.getData("Text"));
		}

		if (this.regexp) {
			this.isRegexp(regexp, evt, evt.clipboardData.getData("Text"));
		}

		if (this.mask?.length) this.$emit('keyPaste', MaskUtils.to(evt.clipboardData.getData('text'), this.mask));
	}

	onFocus(e: any) {
		this.$emit("focus");

		this.focusedInput(e);
	}

	onKeypress(event: KeyboardEvent) {
		if (this.$listeners.enter && event.code.includes('Enter')) {
			event.preventDefault();

			return this.emitEnter();
		}

		const regexpNumber = /^([0-9])+$/g;

		if (this.isNumbers) {
			this.isRegexp(regexpNumber, event, event.key);
		}

		const regexp = this.getRegExp();

		if (this.regexp && !regexp.test(event.key)) {
			event.preventDefault();
			return false;
		}

		if (this.maxlength && this.inputValue.length == this.maxlength) {
			event.preventDefault();
			return false;
		}
	}

	clearValue() {
		this.inputValue = "";

		this.$emit('input', '');
		this.focusInput();
	}

	isRegexp(regexp: any, evt: any, key: string) {
		if (!regexp.test(key)) {
			return evt.preventDefault();
		}
	}

	focusedInput(event: { type: string; }) {
		if (event) {
			this.isFocus = !this.isFocus;
			if (event.type == "focus") {
				return this.isActive = true;
			}
			if (this.inputValue.length) {
				return this.isActive = true;
			} else {
				return this.isActive = false;
			}
		}
	}

	getRegExp(): RegExp {
		return this.customRegExp
			? new RegExp(this.customRegExp)
			: /^[a-zA-Z0-9 \/-?:().,'+-]*$/;
	}

	/**
	 * if type=number
	 */
	onKeydown(e: any): void {
		if (this.type == 'number' && (e.key === 'ArrowUp' || e.key === 'ArrowDown')) {
            e.preventDefault();
        }
	}

	valueChanged(e: any) {
		const regexp = this.getRegExp();

		let cursorPosition = null;
		if (this.$refs.input) {
			cursorPosition = this.$refs.input.selectionStart;
		}
		if (this.isKnp) {
			const regexKnp = /^[^A-Za-z]*$/;

			if (!regexKnp.test(e.target.value)) {
				e.target.value = e.target.value.replace(/[A-Za-z]/g, '');
			}

			this.inputValue = e.target.value;
		}

		if (this.excludeBreaks) {
			e.target.value = e.target.value.replace(
				/(\\t)|(\\n)|(\\r)|(\\f)|(\\a)|(\\e)/g, ''
			);
		}

		if (this.regexp) {
			this.inputValue = e.target.value = this.customRegExp
				? e.target.value
				: e.target.value.toUpperCase();

			if (!this.sliceDisabled && !regexp.test(e.target.value)) {
				this.$nextTick(() => {
					e.target.value = this.inputValue = e.target.value.slice(0, -1);
					this.$emit("input", e.target.value);
				});
			} else {
				this.$emit("input", e.target.value);
			}
			if (this.customValidation) {
				this.hasError = !regexp.test(e.target.value);
			}
		} else {
			this.inputValue = this.transform
				? this.transformValue(this.transform, e.target.value)
				: e.target.value;

			this.$emit("input", this.inputValue);

			if (this.maxlength) {
				if (this.inputValue.length > this.maxlength) {
					let newValue = this.inputValue.slice(0, this.maxlength);
					this.$emit("input", newValue);
					this.$nextTick(() => e.target.value = newValue);
					this.inputValue = newValue;
				}
			}
		}

		this.unsetFieldCustomValidityByFieldValue();

		if (this.value && this.value.length < this.minlength) {
			this.hasError = true;
		}

		e.target.style.height = "auto";
		e.target.style.height = `${e.target.scrollHeight}px`;

		if (this.value != this.inputValue) {
			this.validateByRules(this.inputValue);
		}

		this.setCursorPosition(cursorPosition);
	}


	setCursorPosition(cursorPosition: any): void{
		if (cursorPosition !== null) {
			//setting cursor, as it was before event
			this.$refs.input.setSelectionRange(cursorPosition, cursorPosition);
		}
	}

	searchClick(e: any) {
		this.$emit("click", e);
	}

	mounted() {
		if (this.value && this.value.length) this.isActive = true;

		if (this.autofocus) setTimeout(() => this.focusInput(), 200);
	}

	updated() {
		if (this.value && this.value.length) this.isActive = true;
	}

	focusInput() {
		this.$refs.input?.focus();
	}

	get flagIconClass() {
		return "icon-" + this.icon.toLowerCase();
	}

	get showCustomError(): boolean {
		return (this.textFieldShowError !== false && this.showError);
	}

	get realValue(): string {
		return this.value || this.inputValue;
	}

	get realDisabled(): boolean {
		return this.disabled || this.loading || false;
	}

	@Watch('value')
	textFieldValueChanged() {
    if (this.customValidation && this.regexp) {
      const regexp = this.getRegExp();
      this.hasError = !regexp.test(this.value);
      this.customErrorMessage = this.hasError ? (this.$t('createSumPayment.error.validSymbols') as string) : '';
    }
		this.callOnChange(this.value);
	}

	@Watch("isInputClear")
	inputClear() {
		if (this.isInputClear) {
			this.inputValue = "";
			this.isActive = false;
		}
	}

	@Watch("value")
	isRouteChange() {
		if (!this.value) {
			this.inputValue = "";
			if (!this.isFocus) this.isActive = false;
		}

		if (this.value !== this.inputValue) {
			this.inputValue = this.value;

			this.validateByRules(this.inputValue);
		}
	}

	@Emit('enter')
	emitEnter() {}

}

